<template>
    <div>
        <div class="card">
            <div class="card-body">
                <h4>Firma Digital</h4>
                <p class="text-muted">Dibuja tu firma en el siguiente recuadro. Esta firma se utilizará en los documentos generados por el sistema.</p>

                <div class="signature-container text-center mb-3">
                     <canvas ref="signatureCanvas" width="400" height="200" style="border: 1px dashed #ccc; cursor: crosshair;"></canvas>
                </div>

                <div v-if="existingFirmaBase64" class="text-center mb-3">
                    <p class="fw-light">Firma actual:</p>
                    <img :src="existingFirmaBase64" alt="Firma guardada" style="max-width: 200px; height: auto; border: 1px solid #eee;" />
                </div>

                <div class="d-flex justify-content-center align-items-center gap-3">
                    <vs-button @click="saveSignature" color="rgb(59,222,200)"gradient >
                        💾 Guardar Firma
                    </vs-button>
                    <a class="smallText d-flex align-items-center" @click="clearSignature" href="#">Limpiar</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import SignaturePad from 'signature_pad';
    import axios from "axios";
    var config = require("@/config/api.json");
    const API = config.api;

    export default {
        name: "PersonalMedicoFirma",
        props: {
            personal_medico_id: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                signaturePad: null,
                existingFirmaBase64: '', // To store and display the existing signature
            };
        },
        mounted() {
            this.initializeSignaturePad();
            this.fetchSignature(); // Fetch existing signature on component mount
        },
        methods: {
            initializeSignaturePad() {
                const canvas = this.$refs.signatureCanvas;
                // Adjust canvas size based on parent or screen if needed
                // Example: canvas.width = canvas.offsetWidth;
                this.signaturePad = new SignaturePad(canvas, {
                     backgroundColor: 'rgb(255, 255, 255)', // Optional: set background color
                     penColor: 'rgb(0, 0, 255)' // Changed pen color to blue
                });
                 // Handle window resize to redraw signature pad correctly
                window.addEventListener('resize', this.resizeCanvas);
                this.resizeCanvas(); // Initial resize
            },
             beforeDestroy() {
                // Clean up event listener when component is destroyed
                window.removeEventListener('resize', this.resizeCanvas);
            },
            resizeCanvas() {
                const canvas = this.$refs.signatureCanvas;
                if (!canvas) return;
                const ratio = Math.max(window.devicePixelRatio || 1, 1);
                canvas.width = canvas.offsetWidth * ratio;
                canvas.height = canvas.offsetHeight * ratio;
                canvas.getContext("2d").scale(ratio, ratio);
                // Note: Clearing is necessary after resize to avoid distortion
                if (this.signaturePad) {
                    this.signaturePad.clear(); // Clear current drawing
                    // If you need to redraw existing signature after resize, you'd need to store points
                }
            },
            async fetchSignature() {
                if (!this.personal_medico_id) return;
                this.openLoading(); // Assuming openLoading exists in mixin
                try {
                    const response = await axios.get(`${API}/obtener_firma`, {
                        params: { personal_medico_id: this.personal_medico_id },
                    });
                    // Check for firma_url instead of firma_base64
                    if (response.data.status === "success" && response.data.data?.firma_url) {
                        // Construct the full URL by prepending the API base URL
                        // Ensure API doesn't end with '/' and firma_url starts with '/'
                        const apiUrl = API.endsWith('/') ? API.slice(0, -1) : API;
                        const firmaUrl = response.data.data.firma_url.startsWith('/') ? response.data.data.firma_url : `/${response.data.data.firma_url}`;
                        // Add cache-busting parameter
                        this.existingFirmaBase64 = `${apiUrl}${firmaUrl}?t=${new Date().getTime()}`;
                    } else if (response.data.status === "not_found") {
                         this.existingFirmaBase64 = ''; // No signature found
                         // Optional: Notify user if needed
                         // this.notify("info", "No se encontró una firma guardada.");
                    }
                    else {
                        // Handle other potential success statuses or unexpected responses
                        this.existingFirmaBase64 = '';
                        if(response.data.message) {
                            this.notify("info", response.data.message);
                        }
                    }
                } catch (error) {
                    console.error("Error al obtener la firma:", error);
                    this.notify("error", "Error al cargar la firma existente."); // Use notify
                    this.existingFirmaBase64 = ''; // Clear on error
                } finally {
                    this.closeLoading(); // Assuming closeLoading exists in mixin
                }
            },
            clearSignature() {
                if (this.signaturePad) {
                    this.signaturePad.clear();
                }
            },
            async saveSignature() {
                if (!this.signaturePad || this.signaturePad.isEmpty()) {
                    this.notify("info", "Por favor dibuja tu firma antes de guardar."); // Use notify from mixin
                    return;
                }

                const firmaBase64 = this.signaturePad.toDataURL('image/png'); // Get signature as base64 PNG

                try {
                    const payload = {
                        personal_medico_id: this.personal_medico_id,
                        firma_base64: firmaBase64, // Send the base64 string to the backend
                    };
                    const response = await axios.post(`${API}/guardar_firma`, payload); // Replace with your actual endpoint

                    if (response.data.status === "success") {
                        this.notify("success", "Firma guardada exitosamente."); // Use notify from mixin
                        await this.callAudit(this.personal_medico_id,"ACTUALIZAR","firmas",this.personal_medico_id,"Se actualiza firma digital"); // Call audit function
                        this.signaturePad.clear(); // Clear the canvas after saving
                        this.fetchSignature(); // Refresh the displayed signature
                    } else {
                         this.notify("error", response.data.message || "Error al guardar la firma."); // Use notify from mixin
                    }
                } catch (error) {
                    console.error("Error al guardar la firma:", error);
                    this.notify("error", "Error de conexión al guardar la firma."); // Use notify from mixin
                }
            },
        },
    };
</script>

<style scoped>
    .signature-container canvas {
        width: 100%; /* Make canvas responsive */
        max-width: 400px; /* Optional: Limit max width */
        height: 200px; /* Fixed height */
    }
    /* Add other styles as needed */
</style>
